import './index.scss';

const STREAK_MESSAGES = {
  group1: {
    maxDays: 11,
    title: '🎯 Você já está no caminho certo!',
    subtitle:
      'Continue batendo suas metas de estudos todos os dias — ao completar 11 dias seguidos, você entra no grupo dos 50% mais consistentes da comunidade Q! 💪 Cada dia conta — bora garantir o seu lugar!'
  },
  group2: {
    maxDays: 22,
    title: '🔥 Que ritmo!',
    subtitle:
      'Você já é mais constante que metade da galera. Se mantiver esse foco por 22 dias seguidos, vai estar entre os 25% mais engajados do Qconcursos. ✨ Continua firme — a constância é o seu diferencial!'
  },
  group3: {
    maxDays: 48,
    title: '🚀 Impressionante!',
    subtitle:
      'Você já está entre os 25% mais disciplinados da comunidade. Continue estudando e alcance 48 dias seguidos — isso te coloca no top 10% dos alunos mais focados! 🌟 Mostre que consistência é o seu superpoder.'
  },
  group4: {
    maxDays: 82,
    title: '🏅 Você é exemplo de consistência!',
    subtitle:
      'Já faz parte do top 10% mais engajado da comunidade. Que tal buscar 82 dias seguidos e entrar pro top 5%? 💥 Sua dedicação pode inspirar outros a seguirem seu ritmo.'
  },
  group5: {
    maxDays: Infinity,
    title: '💎 Você está entre os 5% mais dedicados da comunidade Q!',
    subtitle:
      'Sua constância é incrível — continue mostrando que a disciplina supera tudo. 📚 Hoje é mais um dia de vitória. Siga construindo o seu legado!'
  }
};

function initializeModal() {
  const $modal = $('#js-study-goal-modal');

  if ($modal.length === 0) {
    return;
  }

  if ($modal.hasClass('study-goal-initialized')) {
    return;
  }

  $modal.addClass('study-goal-initialized');

  async function fetchStudyGoalProgress() {
    const currentUserId = window.currentUser?.id

    if (!currentUserId) {
      return null;
    }

    try {
      const response = await fetch(
        `/api/users/${currentUserId}/used_resources/study_goal_progress`
      );

      if (!response.ok) {
        throw new Error('Failed to fetch study goal progress');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return null;
    }
  }

  function getMessageByStreak(currentStreak, remainingDays, goalTarget) {
    const groups = Object.values(STREAK_MESSAGES);
    const group = groups.find(g => currentStreak < g.maxDays);
    const baseMessage = group || STREAK_MESSAGES.group5;
    
    return {
      ...baseMessage,
      subtitle: baseMessage.subtitle
    };
  }

  function updateModalContent(data) {
    const {
      current_streak,
      record_streak,
      goal_target,
      remaining_days,
      progress_percent
    } = data;

    $modal
      .find('.q-study-goal-stat:eq(0) .q-study-goal-stat-value')
      .text(`${current_streak} ${current_streak === 1 ? 'dia' : 'dias'}`);

    $modal
      .find('.q-study-goal-stat:eq(1) .q-study-goal-stat-value')
      .text(`${record_streak} ${record_streak === 1 ? 'dia' : 'dias'}`);

    $modal
      .find('.q-study-goal-stat-meta .q-study-goal-stat-value')
      .text(`${goal_target} ${goal_target === 1 ? 'dia' : 'dias'}`);

    $modal
      .find('.q-study-goal-progress-info span:eq(0)')
      .text(`${current_streak} ${current_streak === 1 ? 'dia' : 'dias'}`);
    $modal
      .find('.q-study-goal-progress-info span:eq(1)')
      .text(`${goal_target} ${goal_target === 1 ? 'dia' : 'dias'}`);

    const { title, subtitle } = getMessageByStreak(current_streak, remaining_days, goal_target);
    $modal.find('.q-study-goal-title').text(title);
    $modal.find('.q-study-goal-subtitle').text(subtitle);

    if(remaining_days > 0) {
      $modal.find('.q-study-goal-message').text(
        `Faltam ${remaining_days} ${remaining_days === 1 ? 'dia' : 'dias'}. Continue firme, a constância é o diferencial!`
      );
    }

    const $progressFill = $('.js-progress-fill');
    $progressFill.attr('data-progress', progress_percent);

    const $infoSection = $modal.find('.js-study-goal-info');
    const $rewardSection = $modal.find('.js-study-goal-reward');
    const $actionsSection = $modal.find('.js-study-goal-actions');
    const $rewardPreview = $modal.find('.q-study-goal-reward-preview');

    const experimentData = gon?.flags?.experiment_study_goals_rewards;
    const isExperimentActive = experimentData?.active === true;
    const eligibleGoals = experimentData?.goals || [];
    const isGoalEligibleForReward = eligibleGoals.includes(goal_target);
    const isCurrentStreakEligible = eligibleGoals.includes(current_streak);
    const hasCompletedGoal = remaining_days === 0;

    const showRewardRedeem = isExperimentActive && isCurrentStreakEligible && hasCompletedGoal;
    const hasExperimentData = isExperimentActive && experimentData && experimentData.eliteDay;
    const showRewardPreview = hasExperimentData && !hasCompletedGoal;

    $rewardPreview.toggleClass('q-hidden', !showRewardPreview);
    $infoSection.toggleClass('q-hidden', showRewardRedeem);
    $rewardSection.toggleClass('q-hidden', !showRewardRedeem);
    $actionsSection.toggleClass('q-hidden', showRewardRedeem);

    if (showRewardPreview && experimentData?.eliteDay) {
      const eliteDays = experimentData.eliteDay;
      const $rewardValue = $modal.find('.q-study-goal-reward-preview-value');
      $rewardValue.html(
        `Até <strong>${eliteDays} ${eliteDays === 1 ? 'dia' : 'dias'}</strong> de acesso <strong>Elite</strong>`
      );
    }

    if (showRewardRedeem) {
      $modal.find('.q-study-goal-btn-reward')
        .attr('data-goal', goal_target)
        .attr('data-streak', current_streak);
      
      if (experimentData?.eliteDay) {
        const eliteDays = experimentData.eliteDay;
        const $rewardPrizeValue = $modal.find('.q-study-goal-reward-prize-value');
        $rewardPrizeValue.html(
          `Acesso ao <strong>Plano Elite</strong> por ${eliteDays} ${eliteDays === 1 ? 'dia' : 'dias'}`
        );
      }
    }
  }

  $modal.off('shown.bs.modal').on('shown.bs.modal', async function (event) {
    const $body = $modal.find('.q-study-goal-body');
    const $progressFill = $('.js-progress-fill');
    
    $body.addClass('is-loading');
    
    $progressFill.css({
      'width': '0%',
      'transition': 'none'
    });

    $modal.find('.js-study-goal-success').addClass('q-hidden');
    $modal.find('.js-study-goal-info').removeClass('q-hidden');
    $modal.find('.js-study-goal-reward').addClass('q-hidden');

    const data = await fetchStudyGoalProgress();

    if (data) {
      updateModalContent(data);
      
      const experimentData = gon?.flags?.experiment_study_goals_rewards;
      const isExperimentActive = experimentData?.active === true;
      const eligibleGoals = experimentData?.goals || [];
      const isEligibleForReward = isExperimentActive && eligibleGoals.includes(data.current_streak);
      const hasCompletedGoal = data.remaining_days === 0;

      if (isEligibleForReward && hasCompletedGoal) {
        window.UserTracker.emit('event', {
          eventName: 'modal reward offer viewed',
          data: {
            'streak_days': data.current_streak,
            'reward_type': '3 dias elite',
            'source_platform': 'portal',
            'source_project': gon.source_project
          }
        });
      }
      
      setTimeout(() => {
        $body.removeClass('is-loading');
      }, 50);
      
      void $progressFill[0].offsetWidth;
      
      setTimeout(() => {
        $progressFill.css('transition', 'width 0.8s ease-in-out');
        const targetProgress = $progressFill.data('progress');
        $progressFill.css('width', targetProgress + '%');
      }, 150);
    } else {
      $body.removeClass('is-loading');
    }
  });

  $modal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
    const $body = $modal.find('.q-study-goal-body');
    const $progressFill = $('.js-progress-fill');
    
    $progressFill.css('width', '0%');
    $body.removeClass('is-loading');
  });

  async function redeemReward(goalTarget) {
    try {
      const response = await fetch('/api/gifts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        }
      });

      if (response.ok) {
        $modal.find('.js-study-goal-reward').addClass('q-hidden');
        $modal.find('.js-study-goal-success').removeClass('q-hidden');
      } else {
        const error = await response.json();
        alert(error.error || 'Não foi possível resgatar sua recompensa. Tente novamente.');
      }
    } catch (error) {
      alert('Erro ao resgatar recompensa. Tente novamente.');
    }
  }

  $modal.off('click', '.q-study-goal-btn-reward').on('click', '.q-study-goal-btn-reward', function() {
    const $btn = $(this);
    const currentStreak = parseInt($btn.attr('data-streak'));
    
    window.UserTracker.emit('event', {
      eventName: 'button reward redeem clicked',
      data: {
        'streak_days': currentStreak,
        'reward_type': '3 dias elite',
        'source_platform': 'portal',
        'source_project': gon.source_project
      }
    });

    $btn.prop('disabled', true).text('Resgatando...');
    redeemReward(currentStreak).finally(() => {
      $btn.prop('disabled', false).text('Resgatar minha recompensa');
    });
  });

}

document.addEventListener('turbolinks:load', initializeModal);
